import Api from "./Api";
let adminApi = "/v1/admin";

export default {
  createCloudStorage(payload) {
    return Api.post(adminApi + "/add-cloud-Storage", payload);
  },
  deleteCloudStorage(payload) {
    return Api.post(adminApi + "/delete-cloud-Storage", payload);
  },
  setDefaultCloudStorage(payload) {
    return Api.post(adminApi + "/set-default-cloud-Storage", payload);
  },
  createAccount(payload) {
    return Api.post(adminApi + "/create-account", payload);
  },
  deleteAccount(payload) {
    return Api.post(adminApi + "/delete-account", payload);
  },
  setStatus(payload) {
    return Api.post(adminApi + "/set-status-account", payload);
  },
  getListAccount() {
    return Api.get(adminApi + "/get-accounts");
  },
  getServers() {
    return Api.get(adminApi + "/get-server");
  },
  getInfo() {
    return Api.get(adminApi + "/get-info", { timeout: 30 * 60 * 1000 });
  },
  createServer(data) {
    return Api.post(adminApi + "/create-server", data);
  },
  deleteServer(data) {
    return Api.post(adminApi + "/delete-server", data);
  },
  wakeServer(data) {
    return Api.post(adminApi + "/wake-server", data);
  },
  updateServerWakeOnLan(data) {
    return Api.post(adminApi + "/update-server-wol", data);
  },
  updateServer(data) {
    return Api.post(adminApi + "/update-server", data);
  },
  setServerJobStatus(data) {
    return Api.post(adminApi + "/server-job-status", data);
  },
  getServerPowerStatus() {
    return Api.get(adminApi + "/server-power-status");
  },
  shutdownServer(data) {
    return Api.post(adminApi + "/shutdown-server", data);
  },
  createGroup(data) {
    return Api.post(adminApi + "/create-group", data);
  },
  getListVideoOfUser(idUser) {
    return Api.post(adminApi + "/get-list-video-of-user", idUser);
  },
  updateUserRole(user) {
    return Api.post(adminApi + "/update-user-role", user);
  },
  addMemberToGroup(data) {
    return Api.post(adminApi + "/add-member-to-group", data);
  },
  deleteGroup(id) {
    return Api.post(adminApi + "/delete-group", id);
  },
  removeUserFromGroup(user) {
    return Api.post(adminApi + "/remove-user-from-group", user);
  },
  createGoogleDriver(obj) {
    return Api.post(adminApi + "/create-google-driver", obj);
  },
  deleteGoogleDriver(id) {
    return Api.post(adminApi + "/delete-google-driver", id);
  },
  getListVideoOfGroup(data) {
    return Api.post(adminApi + "/get-list-video-of-group", data);
  },
  uploadFont(data) {
    return Api.post(adminApi + "/upload-font", data, {
      timeout: 3600000,
      // headers: {
      //   "Content-Type": "multipart/form-data"
      // }
    });
  },
  deleteFont(id) {
    return Api.post(adminApi + "/delete-font", id);
  },
  createTransition(data) {
    return Api.post(adminApi + "/create-transition", data, {
      timeout: 3600000,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  getTransitions() {
    return Api.get(adminApi + "/get-transitions");
  },
  removeTransition(data) {
    return Api.post(adminApi + "/delete-transition", data);
  },
  updateAccount(payload) {
    return Api.post(adminApi + "/update-account", payload);
  },
  editVoiceName(payload) {
    return Api.post(adminApi + "/update-voice", payload);
  },
  addApiKeyVoice(payload) {
    return Api.post(adminApi + "/add-api-key-voice", payload);
  },
  updateApiKeyVoice(payload) {
    return Api.post(adminApi + "/update-api-key-voice", payload);
  },
  deleteApiKey(payload) {
    return Api.post(adminApi + "/delete-api-key-voice", payload);
  },
  activePackageForUser(payload) {
    return Api.post(adminApi + "/active-package-for-user", payload);
  },
  addApiGoogleCloud(payload) {
    return Api.post(adminApi + "/add-api-key-google-cloud", payload);
  },
  deleteApiGoogleCloud(payload) {
    return Api.post(adminApi + "/delete-api-key-google-cloud", payload);
  },
  topUpAccount(payload) {
    return Api.post(adminApi + "/top-up-account", payload);
  },
  getVideoByUserId(payload) {
    return Api.post(adminApi + "/get-video-by-userid", payload);
  },
  getYoutubeTrackerKeys() {
    return Api.get(adminApi + "/youtube-tracker-keys");
  },
  getIntegrationSettings() {
    return Api.get(adminApi + "/integration-settings");
  },
  saveIntegrationSettings(payload) {
    return Api.put(adminApi + "/integration-settings", payload);
  },
  testIntegrationSettings(type) {
    return Api.post(adminApi + "/integration-settings/test/" + type, {});
  },
  getYoutubeTrackerSettings() {
    return Api.get(adminApi + "/youtube-tracker-settings");
  },
  saveYoutubeTrackerSettings(payload) {
    return Api.put(adminApi + "/youtube-tracker-settings", payload);
  },
  addYoutubeTrackerKeys(payload) {
    return Api.post(adminApi + "/youtube-tracker-keys", payload);
  },
  editYoutubeTrackerKey(id, payload) {
    return Api.put(adminApi + "/youtube-tracker-keys/" + id, payload);
  },
  deleteYoutubeTrackerKey(id) {
    return Api.delete(adminApi + "/youtube-tracker-keys/" + id);
  },
  checkYoutubeTrackerKey(id) {
    return Api.post(adminApi + "/youtube-tracker-keys/" + id + "/check");
  },
  impersonate(userId) {
    return Api.post(adminApi + "/impersonate", { userId });
  }
};



// WEBPACK FOOTER //
// ./src/services/AdminServices.js